var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg18(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.773 144.773",
    style: {
      enableBackground: "new 0 0 144.773 144.773"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 145,
    style: {
      fill: "#FF6726"
    },
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 145,
    id: "SVGID_1_",
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M106.971,116.94c-4.666-8.833-34.666-14.376-34.666-14.376s-30,5.543-34.666,14.376 c-3.449,12.258-6.334,27.833-6.334,27.833h41h41C113.305,144.773,111.357,128.073,106.971,116.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.305,102.564c0,0,30,5.543,34.666,14.376c4.386,11.133,6.334,27.833,6.334,27.833h-41V102.564z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.138,
    y: 84.606,
    style: {
      fill: "#F1C9A5"
    },
    width: 16.334,
    height: 27.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.305,
    y: 84.606,
    style: {
      fill: "#E4B692"
    },
    width: 8.167,
    height: 27.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C"
    },
    d: "M64.138,97.273c1.469,4.217,7.397,6.634,11.751,6.634 c1.575,0,3.107-0.264,4.583-0.747V84.606H64.138V97.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M93.305,67.357c0-17.074-9.402-26.783-21-26.783c-11.598,0-21,9.709-21,26.783 s9.402,30.917,21,30.917C83.903,98.274,93.305,84.432,93.305,67.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M90.109,79.195c-3.807-0.424-6.377-4.783-5.732-9.732c0.637-4.953,4.242-8.63,8.051-8.209 c3.805,0.422,6.371,4.779,5.729,9.732C97.517,75.939,93.916,79.613,90.109,79.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M46.603,70.986c-0.643-4.953,1.924-9.311,5.726-9.732c3.811-0.421,7.416,3.256,8.055,8.209 c0.643,4.949-1.93,9.309-5.734,9.732C50.843,79.613,47.242,75.939,46.603,70.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M93.305,67.357c0-17.074-9.402-26.783-21-26.783v57.7C83.903,98.274,93.305,84.432,93.305,67.357z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F303F"
    },
    d: "M62.371,90.815c0,0-9.057-7.381-7.044-17.107c2.012-9.727,7.044-11.403,7.044-15.766 c8.385,10.064,15.767,17.105,29.183,13.417c4.025,2.349-1.006,14.427-7.045,20.799c17.108-9.393,36.898-43.942-4.361-57.361 C38.888,21.379,27.15,88.803,62.371,90.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3641E"
    },
    d: "M72.304,51.159c10.84,0,19.845,7.834,21.678,18.148c0.224-1.26,0.347-2.554,0.347-3.877 c0-12.163-9.86-22.024-22.025-22.024c-12.163,0-22.023,9.861-22.023,22.024c0,1.323,0.123,2.617,0.348,3.877 C52.46,58.993,61.464,51.159,72.304,51.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA582A"
    },
    d: "M56.287,106.577c2.938,1.574,9.807,4.855,16.017,4.855c8.168,0,18.845-4,18.845-4l-1.469-0.423 c-3.341-1.089-6.661-1.994-9.497-2.698c-8.118,4.865-16.036,0.076-16.044,0.071C61.756,104.979,59.05,105.715,56.287,106.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1594A3"
    },
    d: "M106.971,116.94c-1.578-2.987-6.056-5.596-11.287-7.743c-2.888,10.196-12.258,17.67-23.379,17.67 s-20.491-7.474-23.379-17.67c-5.231,2.148-9.709,4.756-11.287,7.743c-3.449,12.258-6.334,27.833-6.334,27.833h41h41 C113.305,144.773,111.357,128.073,106.971,116.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA582A"
    },
    d: "M119.941,101.12c-4.5-1.604-11.667,1.896-16.375,1.444c-5.145-0.494-7.93,3.002-11.094,2.368 c-6.083-1.219-6.643,0.985-6.643,0.985s-1.471-2.985,4.613-2.011c6.084,0.975,10.734-1.933,12.124-3.808 c2.101-2.834,9.125-2.166,9.125-2.166l-3.666-4.251c-2.583-0.5-6.417-0.167-8.5,3.417c-2.083,3.584-4,4-9.845,3.333 c-5.845-0.667-9.497,3.879-9.497,3.879l11.05,3.216c0,0,2.28,0.622,4.614,0.562c2.334-0.061,4.774-2.464,9.656-2.094 c5.229,0.396,9.979-2.146,16.132,0.154L119.941,101.12z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.2e66ad41c7a4281e9261d5eb665033f0.svg";
export { ForwardRef as ReactComponent };